/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

export type THttpServiceConfig = {
  baseURL?: string;
  headers?: { [key: string]: string };
};

export type THttpService = {
  get: (url: string, config?: THttpServiceConfig) => Promise<any>;
  post: (url: string, data?: any, config?: THttpServiceConfig) => Promise<any>;
  put: (url: string, data?: any, config?: THttpServiceConfig) => Promise<any>;
};

export function HttpService(config: THttpServiceConfig) {
  return axios.create(config) as THttpService;
}
